"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Oval = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Oval = function Oval(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      width: props.width,
      height: props.height,
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: props.color,
      "aria-label": props.label
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      transform: "translate(1 1)",
      strokeWidth: "2"
    },
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      strokeOpacity: ".5",
      cx: "18",
      cy: "18",
      r: props.radius
    }),
    /*#__PURE__*/
    _react["default"].createElement("path", {
      d: "M36 18c0-9.94-8.06-18-18-18"
    },
    /*#__PURE__*/
    _react["default"].createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "1s",
      repeatCount: "indefinite"
    })))))
  );
};

exports.Oval = Oval;
Oval.propTypes = {
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  color: _propTypes["default"].string,
  label: _propTypes["default"].string,
  radius: _propTypes["default"].number
};
Oval.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading",
  radius: 18
};